import { createActionCreator } from '@pressreader/appstore';
import type { LinkKind } from '@pressreader/content-types';

import { MODULE_NAME } from '../../constants';

const prefix = `${MODULE_NAME}/content-link/`;

export const articleContentLinkClickedAction = createActionCreator<{
    kind: LinkKind;
}>(`${prefix}article-content-link-clicked`);
